/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  IDataCollectionStateProps,
  IProjectInfoAction,
  IProjectInfoCmnStateProps,
} from 'interface/project/projectInfo';
import { useProjectInfoDispatch, useProjectInfoState } from 'provider/ProjectInformationProvider';
import { useCallback } from 'react';

interface IUseProjectInfoProviderProps {
  inputs: IProjectInfoCmnStateProps;
  dcInputs: IDataCollectionStateProps;
  dispatch: React.Dispatch<IProjectInfoAction>;
  onChange: (_name: string, _value: any) => void;
  onReset: () => void;
  onChangeDC: (_name: string, _value: any) => void;
}
function useProjectInfoProvider(): IUseProjectInfoProviderProps {
  const state = useProjectInfoState();
  const { inputs, dcInputs } = state;
  const dispatch = useProjectInfoDispatch();
  const onChange = useCallback(
    (_name: string, _value: any) => {
      dispatch({
        type: 'handleChangeByType',
        payload: {
          type: 'inputs',
          name: _name,
          value: _value,
        },
      });
    },
    [dispatch],
  );
  const onReset = useCallback(() => {
    dispatch({
      type: 'reset',
    });
  }, [dispatch]);

  // DC Inputs
  const onChangeDC = useCallback(
    (_name: string, _value: any) => {
      dispatch({
        type: 'handleChangeByType',
        payload: {
          type: 'dcInputs',
          name: _name,
          value: _value,
        },
      });
    },
    [dispatch],
  );

  return {
    inputs,
    dcInputs,
    dispatch,
    onChange,
    onReset,
    onChangeDC,
  };
}

export default useProjectInfoProvider;
